import { initializeApp, getApp, getApps } from "firebase/app";
import { getAuth, onAuthStateChanged, signInAnonymously } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

function readEnv(key) {
  return String(process.env[key] || "").trim();
}

const firebaseConfig = {
  apiKey: readEnv("REACT_APP_FIREBASE_API_KEY"),
  authDomain: readEnv("REACT_APP_FIREBASE_AUTH_DOMAIN"),
  projectId: readEnv("REACT_APP_FIREBASE_PROJECT_ID"),
  storageBucket: readEnv("REACT_APP_FIREBASE_STORAGE_BUCKET"),
  messagingSenderId: readEnv("REACT_APP_FIREBASE_MESSAGING_SENDER_ID"),
  appId: readEnv("REACT_APP_FIREBASE_APP_ID"),
};

export const isFirebaseConfigured = Boolean(
  firebaseConfig.apiKey &&
    firebaseConfig.authDomain &&
    firebaseConfig.projectId &&
    firebaseConfig.appId
);

export const firebaseApp = isFirebaseConfigured
  ? getApps().length
    ? getApp()
    : initializeApp(firebaseConfig)
  : null;

export const firebaseAuth = firebaseApp ? getAuth(firebaseApp) : null;
export const firebaseDb = firebaseApp ? getFirestore(firebaseApp) : null;
export const firebaseStorage = firebaseApp ? getStorage(firebaseApp) : null;

let authReadyPromise = null;

export function isPermissionDeniedError(error) {
  const code = String(error?.code || "");
  const message = String(error?.message || "");
  return (
    code === "permission-denied" ||
    code === "storage/unauthorized" ||
    /missing or insufficient permissions/i.test(message) ||
    /permission[- ]denied/i.test(message)
  );
}

export function explainFirebaseError(error) {
  if (isPermissionDeniedError(error)) {
    return (
      "Firebase izin hatası: Firestore/Storage kuralları reklam okuma-yazmaya izin vermiyor. " +
      "Firebase Console → Firestore Rules ve Storage Rules içine ads kurallarını ekleyin; " +
      "Authentication → Anonymous’u açın. Şimdilik yerel depolama kullanılıyor."
    );
  }
  if (error?.code === "auth/operation-not-allowed") {
    return (
      "Anonim giriş kapalı. Firebase Console → Authentication → Sign-in method → Anonymous’u etkinleştirin."
    );
  }
  return error?.message || "Firebase hatası";
}

/** Storage/Firestore yazmaları için anonim oturum. */
export async function ensureFirebaseAuth() {
  if (!firebaseAuth) {
    throw new Error("Firebase yapılandırılmamış. web/.env dosyasını kontrol edin.");
  }
  if (firebaseAuth.currentUser) return firebaseAuth.currentUser;

  if (!authReadyPromise) {
    authReadyPromise = new Promise((resolve, reject) => {
      const unsub = onAuthStateChanged(firebaseAuth, (user) => {
        if (user) {
          unsub();
          resolve(user);
        }
      });
      signInAnonymously(firebaseAuth)
        .then((cred) => {
          unsub();
          resolve(cred.user);
        })
        .catch((err) => {
          unsub();
          authReadyPromise = null;
          reject(err);
        });
    });
  }

  return authReadyPromise;
}

/** Auth zorunlu değilse sessiz dene (public read kuralları için). */
export async function tryEnsureFirebaseAuth() {
  try {
    return await ensureFirebaseAuth();
  } catch {
    return null;
  }
}
